import { render, staticRenderFns } from "./no-accept.vue?vue&type=template&id=b158a642&"
import script from "./no-accept.vue?vue&type=script&lang=js&"
export * from "./no-accept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports